import getSplashApiClient from 'lib/SplashApiClient/singleton';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import axios from 'axios';

export const librarianServiceUrl = getBootstrap().get('librarian.serviceUrl');

/**
 * Wraps a SplashApiClient with Team API actions
 */
export default class CssApiClient {
    /**
     * @param {SplashApiClient} apiClient
     * @param {number | string} eventId
     */
    constructor(apiClient, eventId) {
        this.apiClient = apiClient;
        this.eventId = eventId;
        this.requestOptions = {
            headers: {
                'X-Splash-Event-Id': eventId,
            },
        };
    }

    getCssFileBySection = async (section, isEditing) => {
        try {
            const response = isEditing
                ? this.getAdminCssFileBySection(section)
                : this.getPublicCssFileBySection(section);

            return response;
        } catch (error) {
            return null;
        }
    };

    getAdminCssFileBySection = async (section) => {
        const adminCssFileUrl = `/librarian/v1/admin/cssFiles/events/${this.eventId}/${section}`;
        const data = await this.apiClient.get(adminCssFileUrl, {}, { ...this.requestOptions });
        return data.data;
    };
    getPublicCssFileBySection = async (section) => {
        const publicCssFileUrl = `${librarianServiceUrl}/v1/api/cssFiles/events/${this.eventId}/${section}`;
        const data = await axios.get(publicCssFileUrl, { ...this.requestOptions });
        return data.data;
    };

    saveCssFiles = async ({ section, userId, document }) => {
        const saveCssFilesUrl = `/librarian/v1/admin/cssFiles/events/${this.eventId}/${section}`;

        const saveData = {
            userId: parseInt(userId, 10),
            document,
        };
        const response = await this.apiClient.put(saveCssFilesUrl, saveData, { ...this.requestOptions });

        return response.data;
    };
}

export const getCssFileApiClient = (eventId) => new CssApiClient(getSplashApiClient(), eventId);
